import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  CircularProgress,
  ClickAwayListener,
  Divider,
  Fab,
  Grid,
  Grow,
  IconButton,
  Paper,
  Popper,
  TextField,
  Typography,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import CommonSlider from "./CommonSlider";
import moment from "moment";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRange } from "react-date-range";
import { dateFormat, displaySlots } from "../constants/Calendar-constants";
import { blockMultipleRooms } from "../../InventoryCalendar/api/InventoryApi";
import { shallowEqual, useSelector } from "react-redux";
import { toast } from "material-react-toastify";
import { useTranslation } from "react-i18next";
import i18n from "../../../modules/Auth/pages/i18n";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  textField: {
    padding: theme.spacing(2),
  },
  custom_box: {
    width: "100%",
    padding: theme.spacing(2),
    whiteSpace: "no-wrap",
    borderRadius: 10,
  },
}));

const BlockView = (props) => {
  const { hotel } = useSelector(
    ({ auth }) => ({
      hotel: auth.selectedHotel,
    }),
    shallowEqual
  );
  const {
    open,
    eventData,
    closeFunc,
    reload,
    modalClose,
    reloadagain,
    viewType,
    showBlockRoomError,
    selectedLanguage,
    selectedCheckinSlot,
    selectedCheckoutSlot,
    isSingleSlot,
  } = props;
  const { t } = useTranslation();

  useEffect(() => {
    i18n.changeLanguage(selectedLanguage);
  }, [selectedLanguage]);

  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [loading, setLoading] = useState(false);

  const [currentDateSelection, setCurrentDateSelection] = useState(() => {
    const startDate = new Date(eventData.start);
    let endDate = new Date(eventData.end);

    if (
      viewType !== "resourceTimelineDay" &&
      viewType === "resourceTimelineWeek" &&
      hotel.slotType !== "NOON" &&
      displaySlots[eventData.end.getHours()] !== 0
    ) {
      endDate = new Date(eventData.end);
    } else {
      endDate = new Date(eventData.end);
    }

    // Extract only year, month, and day for proper date comparison
    const startDay = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const endDay = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    // Calculate full days difference
    const dayDiff = Math.ceil((endDay - startDay) / (1000 * 60 * 60 * 24));
    console.log("dayDiff", dayDiff);

    // Reduce endDate by one day only if the difference is >= 1
    if (isSingleSlot && dayDiff >= 1) {
      endDate.setDate(endDate.getDate() - 1);
    }

    return [{ startDate, endDate }];
  });

  const [showDatePicker, setShowDatePicker] = useState(false);
  const [reason, setReason] = useState("");

  console.log("selectedCheckinSlot", selectedCheckinSlot, selectedCheckoutSlot);

  const unblock = async () => {
    try {
      setLoading(true);
      const payload = {
        startDate: moment(currentDateSelection[0].startDate).format(
          `DD-MM-YYYY ${selectedCheckinSlot}:00:00`
        ),
        endDate: moment(currentDateSelection[0].endDate).format(
          `DD-MM-YYYY ${selectedCheckoutSlot}:00:00`
        ),
        physicalRoomIds: [eventData.resource.id],
        reason: reason,
      };
      await blockMultipleRooms([payload]).then(() => {
        toast.success(`${t("Successfully blocked")}`);
      });
      reload();
      if (sessionStorage.getItem("types") === "month") {
        reloadagain();
        reloadagain();
      }

      closeFunc();
    } catch (e) {
      toast.error(
        `${t(
          "Selected rooms could not be blocked since they have future reservations."
        )}`
      );
      console.log(e);
      closeFunc();
    }
  };

  const getDateText = () => {
    let val = "";
    val =
      val +
      moment(currentDateSelection[0].startDate).format("DD MMM YYYY") +
      " - ";
    val = val + moment(currentDateSelection[0].endDate).format("DD MMM YYYY");
    return val;
  };

  return (
    <div className={classes.root}>
      <CommonSlider
        onBackdropClick={closeFunc}
        onClose={modalClose}
        open={open}
      >
        <Grid container className={classes.textField}>
          <Grid item xs={10} alignSelf="center">
            <Typography variant="h5">{t("Block rooms")}</Typography>
          </Grid>
          <Grid item xs={2}>
            <IconButton
              onClick={() => {
                modalClose();
              }}
              sx={{ float: "right" }}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>

        <Grid container spacing={2} className={classes.textField}>
          <Grid item xs={12}>
            <Box
              className={classes.custom_box}
              bgcolor={"#36454F"}
              style={{ color: "white" }}
            >
              <Typography>
                {`${t("You are currently blocking room number : ")} ${
                  eventData.resource.id
                }`}
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12}>
            <div>
              <ClickAwayListener
                onClickAway={() => {
                  setShowDatePicker(false);
                  setAnchorEl(null);
                }}
              >
                <div>
                  <TextField
                    fullWidth
                    focused={showDatePicker}
                    id="currentDateSelection"
                    name="currentDateSelection"
                    InputProps={{ readOnly: true }}
                    value={getDateText()}
                    label={t("Date range")}
                    onClick={(eve) => {
                      setAnchorEl(eve.currentTarget);
                      setShowDatePicker(true);
                    }}
                  ></TextField>
                  {showDatePicker && (
                    <Popper
                      style={{ zIndex: 2 }}
                      open={showDatePicker}
                      anchorEl={anchorEl}
                      placement="bottom"
                      transition
                      disablePortal
                    >
                      {({ TransitionProps, placement }) => (
                        <Grow
                          style={{
                            transformOrigin: (placement = "bottom-end"),
                          }}
                          {...TransitionProps}
                        >
                          <Paper
                            elevation={5}
                            className="inventory-daterange-custom"
                          >
                            <DateRange
                              color="#1BC5BD"
                              rangeColors={["#1BC5BD"]}
                              editableDateInputs={false}
                              moveRangeOnFirstSelection={false}
                              onChange={(data) => {
                                setCurrentDateSelection([{ ...data.range1 }]);
                              }}
                              ranges={currentDateSelection}
                              minDate={new Date()}
                            ></DateRange>
                          </Paper>
                        </Grow>
                      )}
                    </Popper>
                  )}
                </div>
              </ClickAwayListener>
            </div>
          </Grid>
          <Grid item xs={12}>
            <TextField
              value={reason}
              label={t("Reason")}
              fullWidth
              multiline
              rows={3}
              onChange={(eve) => {
                setReason(eve.target.value);
              }}
            ></TextField>

            {showBlockRoomError && (
              <Box
                className={classes.custom_box}
                bgcolor="#FFF4E5"
                style={{ marginTop: "1rem" }}
              >
                <Typography>
                  {t(
                    `There are unassigned reservations which needs to be assigned, Do you still want to block the rooms ?`
                  )}
                </Typography>
              </Box>
            )}
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid
            item
            xs={12}
            container
            justifyContent="flex-end"
            className={classes.textField}
          >
            <Button
              disabled={loading}
              type="button"
              color="primary"
              onClick={unblock}
              variant="outlined"
              style={{
                backgroundColor: `${"#36454F"}`,
                color: `${"white"}`,
                borderColor: "#36454F",
                fontWeight: "bold",
                textTransform: "none",
              }}
            >
              {t("Block room")}
              {loading && (
                <CircularProgress size={15} color="inherit" sx={{ ml: 1.5 }} />
              )}
            </Button>
          </Grid>
        </Grid>
      </CommonSlider>
    </div>
  );
};

export default BlockView;
